// Atalhos de teclado globais — docs/07-dashboard/DASHBOARD_UI_SPECS.md.
// handlers: { a, enter, r, escape, question } -> () => void
export function registerKeyboardShortcuts(handlers) {
  function onKeydown(event) {
    const target = event.target;
    const isTyping = target instanceof HTMLElement && ["INPUT", "TEXTAREA"].includes(target.tagName);

    if (event.key === "Escape") {
      handlers.escape?.();
      return;
    }

    if (isTyping) return;

    switch (event.key) {
      case "a":
      case "A":
        handlers.a?.();
        break;
      case "Enter":
        handlers.enter?.();
        break;
      case "r":
      case "R":
        handlers.r?.();
        break;
      case "?":
        handlers.question?.();
        break;
    }
  }

  window.addEventListener("keydown", onKeydown);
  return () => window.removeEventListener("keydown", onKeydown);
}
